/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle, Fields, arrayFrom, getState } from '../../../twd/twd'

const state = getState('municipals.use-search-holding')

export default ({selected, setSelected }) => {
    const [text, setText] = React.useState('')
    const [searchResults, setSearchResults] = React.useState([])

    React.useEffect(() => {
        let a = getHoldings({text, selected})
        setSearchResults(a)
    }, [text, selected])

    const isAll = selected.length === arrayFrom(state.value.holdings).length

    return <React.Fragment>
    <Fields.Search
        dataName="municipals-market-news-holdings"
        placeholder={ isAll ? 'All' : 'Selected' }
        type="select"
        onSelect={(a) => {
            let arr = a.value==='*'
                ? (isAll ? [] : [...searchResults])
                : arrayToggle([...selected], (b) => isEq(a,b), a)

            setSelected([...arr])
        }}
    >
    {({keyword : text}) => {
        setText(text)

        return <React.Fragment>
        { searchResults.length>1 && <React.Fragment>
            <Fields.SearchOption
                dataName="municipals-market-news-holding-select-all"
                item={{value:'*'}}>
            <Fields.CheckboxLabel
                dataName="municipals-market-news-holding-select-all-label"
                checked={isAll}
                label="Select all" />
            </Fields.SearchOption>
            <hr aria-hidden="true" />
        </React.Fragment>}
        {
            searchResults.map((a,i) => (
                <Fields.SearchOption
                    dataName="municipals-market-news-holding"
                    item={a}
                    key={i}>
                <Fields.CheckboxLabel
                    dataName="municipals-market-news-holding-label"
                    checked={a.selected}
                    label={a.label}
                    className="text-truncate" />
                </Fields.SearchOption>)
            )
        }
        </React.Fragment>

    }}
    </Fields.Search>
    </React.Fragment>
}



const getHoldings = ({text='', selected=[]} = {}) => {
    let t = text.toLowerCase()
    return arrayFrom(state.value.holdings)
        .map(a => Object.assign({...a}, {
            selected: !!selected.find((b) => isEq(a,b))
        }))
        .filter(a => !text
            || a.label.toLowerCase().indexOf(t) >= 0)
}

const isEq = (a, b) => a.label === b.label